import { Breadcrumbs, Typography } from "@mui/material";
import { NavigateNext as NavigateNextIcon } from "@mui/icons-material";

import Link from "components/shared/Link";
import useCatalogDetail from "hooks/useCatalogDetail";

export const PanelHeaderBreadcrumb: React.FC<{
  parent: { url?: string; label?: string };
}> = ({ parent }) => {
  const { customize } = useCatalogDetail();

  return (
    <Breadcrumbs separator={<NavigateNextIcon />}>
      <Link color="secondary" url={parent?.url}>
        <Typography variant="h6">{parent?.label}</Typography>
      </Link>
      <Typography variant="h6">
        {customize ? "Customize Panel" : "View Panel"}
      </Typography>
    </Breadcrumbs>
  );
};
